module.exports = __webpack_public_path__ + "img/cancel-icon.2482b839.svg";